export default __webpack_public_path__ + "static/media/search-github-users.77b14d8d.png";